<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :product-group="productGroup"
            :all-product-groups="allProductGroups"
            :selected-parent-groups="inertiaSelectedParentGroups"
            :selected-child-groups="inertiaSelectedChildGroups"
            :selected-product-group-brands="selectedProductGroupBrands"
            :brands="brands"
            :linked-products="linkedProducts"
            @form-submitted="submitData"
        />
    </DCard>
    <DCard
        padding
        class="mt-5"
        :title="__('products.productGroups.update.table.title')"
    >
        <DRow>
            <DCol lg="12">
                <DTable
                    :items="productGroup.addon_products"
                    :fields="fields"
                >
                    <template #name="{item}">
                        <td v-if="userPermissions.includes('product.view')">
                            <Link
                                v-if="userPermissions.includes('product.view')"
                                :href="viewProductUrl(item.id)"
                            >
                                {{ item.name }}
                            </Link>
                        </td>
                        <td v-else>
                            {{ item.name }}
                        </td>
                    </template>
                </DTable>
            </DCol>
        </DRow>
    </DCard>
</template>
<script>
import Form from '~@/Components/Products/ProductAddonGroups/Form'
import { __ } from '~@/Composables/translation'

export default {
    name: 'ProductAddonGroupsUpdate',
    components: {
        Form
    },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        productGroup: {
            type: Object,
            default: () => { return {} }
        },
        allProductGroups: {
            type: Array,
            default () {
                return []
            }
        },
        inertiaSelectedParentGroups: {
            type: Array,
            default () {
                return []
            }
        },
        inertiaSelectedChildGroups: {
            type: Array,
            default () {
                return []
            }
        },
        brands: {
            type: Array,
            default () {
                return []
            }
        },
        selectedProductGroupBrands: {
            type: Array,
            default () {
                return []
            }
        },
        linkedProducts: {
            type: Array,
            default () {
                return []
            }
        }
    },
    data () {
        return {
            fields: [
                { key: 'id', label: __('products.productGroups.update.table.id') },
                { key: 'name', label: __('products.productGroups.update.table.name') },
                { key: 'retired', label: __('products.productGroups.update.table.retired') }
            ]
        }
    },
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        }
    },
    methods: {
        submitData (form) {
            form.put(this.$route('products.product-addon-groups.update', this.productGroup.id))
        },
        updateSelectedParentGroups (values) {
            this.form.form_selected_parent_groups = values
        },
        updateSelectedChildGroups (values) {
            this.form.form_selected_child_groups = values
        },
        viewProductUrl (id) {
            return this.$route('products.products.show', {
                product: id
            })
        }
    }
}
</script>
